import React from "react";
import Data from "../DATA.json";

const beforeTechTags = ["Stakeholder management", "Team leadership", "Agile", "KPIs and OKRs"];

const Management = () => {
  const managements = Data.management.slice(0, 5);

  return (
    <>
      <section
        id="management"
        className="mb-16 scroll-mt-16 md:mb-24 lg:mb-36 lg:scroll-mt-24"
        aria-label="before tech"
      >
        <div className="sticky top-0 z-20 mx-0 mb-4 md:w-screen sm:w-full bg-zinc-900/75 px-6 py-5 backdrop-blur md:-mx-12 md:px-12 lg:relative lg:top-auto lg:mx-auto lg:w-full lg:px-0 lg:py-0 lg:opacity-0">
          <h2 className="text-sm font-bold uppercase tracking-widest text-slate-200">
            Before tech
          </h2>
          <style>
            {`
            .img-wrapper {
              width: 200px;
              height: 100px;
              object-fit: cover; /* Maintain aspect ratio and fill container */
            `}
          </style>
        </div>
        <div className="mb-12">
          <h3 className="font-medium leading-snug text-slate-200">
            Before tech: 10+ years of project leadership
          </h3>
          <p className="mt-2 text-sm leading-normal">
            Before moving into software, I led projects and teams in Brazil. That experience taught me to plan under real constraints, align very different stakeholders and take ownership of outcomes.
          </p>
          <ul className="mt-2 flex flex-wrap" aria-label="Skills">
            {beforeTechTags.map((tag) => (
              <li key={tag} className="mr-1.5 mt-2">
                <div className="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300">
                  {tag}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <ol className="group/list">
            {managements.map((item) => (
              <li key={item.id} className="mb-12">
                <div className="group relative grid gap-4 pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50">
                  <div className="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-zinc-900/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"></div>
                  <header
                    className="z-10 mb-2 mt-1 text-xs font-semibold uppercase tracking-wide text-slate-500 sm:col-span-2"
                    aria-label={item.image}
                  >
                    <img
                      alt={item.title}
                      loading="lazy"
                      width="200"
                      height="48"
                      decoding="async"
                      data-nimg="1"
                      className="img-wrapper z-10 rounded border-2 border-slate-200/10 transition group-hover:border-slate-200/30 sm:order-1 sm:col-span-2 sm:translate-y-1"
                      style={{ color: "transparent" }} // Fix the style attribute here
                      aria-label={item.image}
                      src={item.image}
                    />
                  </header>
                  <div className="z-10 sm:col-span-6">
                    <h3 className="font-medium leading-snug text-slate-200">
                      <div>
                        <span className="text-base font-medium leading-tight text-slate-200">
                          {item.title}
                        </span>
                      </div>
                      <div>
                        <div className="text-slate-500" aria-hidden="true">
                          {item.date}
                        </div>
                      </div>
                      <div>
                        <div className="text-slate-500" aria-hidden="true">
                          {item.country}
                        </div>
                      </div>
                    </h3>
                    <p className="mt-2 text-sm leading-normal">
                      {item.description}
                    </p>
                    <ul
                      className="mt-2 flex flex-wrap"
                      aria-label="Technologies used"
                    >
                      {item.techStacks.map((tech) => (
                        <li key={tech} className="mr-1.5 mt-2">
                          <div className="flex items-center rounded-full bg-teal-400/10 px-3 py-1 text-xs font-medium leading-5 text-teal-300">
                            {tech}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
};
export default Management;
